@import "../../styles/InputMixins";

:host {
  display: block;
}

.input {
  @include input-control;

  &[aria-invalid="true"] {
    padding-right: 46px;
  }
}

.inputContainer {
  @include input-container;
}

.errorIcon {
  @include input-error-icon;
}

.inputLabel {
  @include input-label;
}

.errorInfo {
  @include input-error;
}
